module.exports = __webpack_public_path__ + "img/img-11.66ed6b5b.png";